import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Browse from '../../../containers/Browse/Browse';
import OpeningDetail from '../../../containers/Browse/OpeningDetail/OpeningDetail';
import { useOrganizationSelector } from '../../../hooks/useOrganizationSelector';

const BrowseBase = ({ isPublic }) => {
  useOrganizationSelector();
  return (
    <Routes>
      <Route>
        <Route exact path="/" key="all" element={<Browse tab="all" isPublic={isPublic} />} />
        <Route exact path="/details/:jobId" element={<OpeningDetail isPublic={isPublic} />} />
      </Route>
    </Routes>
  );
};

export default BrowseBase;
